module.exports = __webpack_public_path__ + "static/media/cap3-01-desk.1c8d70fd.jpg";